import { ExcelStyle } from '@ag-grid-community/core';

export const AG_TABLE_ROW_HEIGHT = 32;
export const AG_TABLE_HEADER_HEIGHT = AG_TABLE_ROW_HEIGHT;
export const EM_DASH = '—';
export const EXCEL_STYLES: ExcelStyle[] = [
  {
    id: 'header',
    font: {
      bold: true,
    },
  },
  {
    id: 'rightAligned',
    alignment: {
      horizontal: 'Right',
    },
  },
];
